import api from "./api";

/**
 * Obtiene el historial de auditoría con filtros opcionales
 * @param {Object} params - { tabla, usuario_id, accion }
 */
export const getLogsAuditoria = async (params = {}) => {
  try {
    const response = await api.get("/auditoria", { params });
    return response.data;
  } catch (error) {
    console.error("❌ Error en auditoriaService:", error);
    throw error;
  }
};
